import { Skeleton } from 'src/components/ui/skeleton';

/**
 * Loading placeholder for the trace table. Mirrors the real layout — stat
 * strip, filter bar, indented span rows — so the panel keeps its shape while
 * the first timeline fetch lands instead of collapsing to a bare spinner.
 */
export function TraceSkeleton({
  compact = false,
  rows = 6,
}: {
  compact?: boolean;
  rows?: number;
}) {
  return (
    <div
      className="flex flex-col border border-border rounded-lg overflow-hidden bg-white"
      aria-busy="true"
    >
      {/* Stat strip */}
      {!compact && (
        <div className="flex items-stretch border-b border-border bg-stone-50">
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={i}
              className="flex flex-col gap-1 px-3.5 py-2 border-r border-border flex-1 min-w-0"
            >
              <Skeleton className="h-2 w-14" />
              <Skeleton className="h-3.5 w-16" />
              <Skeleton className="h-2 w-20" />
            </div>
          ))}
        </div>
      )}

      {/* Filter bar */}
      <div className="border-b border-border px-3 py-2 bg-white flex items-center gap-2">
        <Skeleton className="h-7 w-48 rounded-md" />
        <Skeleton className="h-7 w-20 rounded-md" />
        <div className="flex-1" />
        <Skeleton className="h-6 w-16 rounded-md" />
        <Skeleton className="h-6 w-20 rounded-md" />
      </div>

      {/* Column headers */}
      <div className="flex items-center gap-2 px-3 h-[30px] border-b border-border bg-stone-50">
        <Skeleton className="h-2 w-16" />
        <div className="flex-1" />
        <Skeleton className="h-2 w-12" />
        <Skeleton className="h-2 w-12" />
        <Skeleton className="h-2 w-12" />
      </div>

      {/* Span rows — staggered indents read as a tree */}
      <div className="divide-y divide-border">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="flex items-center gap-2 h-8 px-3">
            <div style={{ width: `${(i % 3) * 18}px` }} />
            <Skeleton className="h-3 w-3 rounded-sm shrink-0" />
            <Skeleton
              className="h-3"
              style={{ width: `${120 + ((i * 37) % 90)}px` }}
            />
            <div className="flex-1" />
            <Skeleton className="h-3 w-14 shrink-0" />
            <Skeleton className="h-3 w-10 shrink-0" />
            <Skeleton className="h-3 w-10 shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
}
